/* tslint:disable */
/* eslint-disable */
/**
 * New Train Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CancelBeforeReserveResponse } from '../model';
// @ts-ignore
import { CancelRequest } from '../model';
// @ts-ignore
import { CaptchaResult } from '../model';
// @ts-ignore
import { CheckFinalizabilityResult } from '../model';
// @ts-ignore
import { CheckReserveResult } from '../model';
// @ts-ignore
import { CompleteReserveResult } from '../model';
// @ts-ignore
import { FinalizeManualReserveRequest } from '../model';
// @ts-ignore
import { PenaltyResult } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { RefundTicketReportItem } from '../model';
// @ts-ignore
import { RegisterInfoRequest } from '../model';
// @ts-ignore
import { RegisterInfoResponse } from '../model';
// @ts-ignore
import { ReserveSeatResult } from '../model';
// @ts-ignore
import { ReverseCancelResponse } from '../model';
// @ts-ignore
import { SaleTicketReportItem } from '../model';
// @ts-ignore
import { StartManualReserveRequest } from '../model';
// @ts-ignore
import { StartManualReserveResponse } from '../model';
// @ts-ignore
import { TicketsInfo } from '../model';
/**
 * ReservesApiApiCancelBeforeReserveGet - axios parameter creator
 * 
 * @param {number} reserveID 
 * @param {number} [performerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiCancelBeforeReserveGetAxiosParamCreator (reserveID: number, performerId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveID' is not null or undefined
    assertParamExists('apiCancelBeforeReserveGet', 'reserveID', reserveID)
    const localVarPath = `/api/CancelBeforeReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['reserveID'] = reserveID;
    }

    if (performerId !== undefined) {
        localVarQueryParameter['performerId'] = performerId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiCancelPost - axios parameter creator
 * 
 * @param {CancelRequest} [cancelRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiCancelPostAxiosParamCreator (cancelRequest?: CancelRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Cancel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancelRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiCheckFailureGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiCheckFailureGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CheckFailure`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiCheckFinalizabilityGet - axios parameter creator
 * 
 * @param {number} [billId] 
 * @param {number} [reserveID] 
 * @param {number} [captchaInputId] 
 * @param {string} [captchaInputText] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiCheckFinalizabilityGetAxiosParamCreator (billId?: number, reserveID?: number, captchaInputId?: number, captchaInputText?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CheckFinalizability`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }

    if (reserveID !== undefined) {
        localVarQueryParameter['reserveID'] = reserveID;
    }

    if (captchaInputId !== undefined) {
        localVarQueryParameter['CaptchaInput.Id'] = captchaInputId;
    }

    if (captchaInputText !== undefined) {
        localVarQueryParameter['CaptchaInput.Text'] = captchaInputText;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiCheckReserveGet - axios parameter creator
 * 
 * @summary check reserve
 * @param {number} [reserveID] 
 * @param {boolean} [overrideTooManyRequests] 
 * @param {boolean} [overrideLastUser] 
 * @param {boolean} [writeComments] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiCheckReserveGetAxiosParamCreator (reserveID?: number, overrideTooManyRequests?: boolean, overrideLastUser?: boolean, writeComments?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CheckReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['ReserveID'] = reserveID;
    }

    if (overrideTooManyRequests !== undefined) {
        localVarQueryParameter['OverrideTooManyRequests'] = overrideTooManyRequests;
    }

    if (overrideLastUser !== undefined) {
        localVarQueryParameter['OverrideLastUser'] = overrideLastUser;
    }

    if (writeComments !== undefined) {
        localVarQueryParameter['WriteComments'] = writeComments;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiCompleteReserveGet - axios parameter creator
 * 
 * @param {number} [reserveID] 
 * @param {boolean} [overrideTooManyRequests] 
 * @param {boolean} [overrideLastUser] 
 * @param {boolean} [doCheckReserve] 
 * @param {boolean} [writeComments] 
 * @param {number} [captchaInputId] 
 * @param {string} [captchaInputText] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiCompleteReserveGetAxiosParamCreator (reserveID?: number, overrideTooManyRequests?: boolean, overrideLastUser?: boolean, doCheckReserve?: boolean, writeComments?: boolean, captchaInputId?: number, captchaInputText?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CompleteReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['ReserveID'] = reserveID;
    }

    if (overrideTooManyRequests !== undefined) {
        localVarQueryParameter['OverrideTooManyRequests'] = overrideTooManyRequests;
    }

    if (overrideLastUser !== undefined) {
        localVarQueryParameter['OverrideLastUser'] = overrideLastUser;
    }

    if (doCheckReserve !== undefined) {
        localVarQueryParameter['DoCheckReserve'] = doCheckReserve;
    }

    if (writeComments !== undefined) {
        localVarQueryParameter['WriteComments'] = writeComments;
    }

    if (captchaInputId !== undefined) {
        localVarQueryParameter['CaptchaInput.Id'] = captchaInputId;
    }

    if (captchaInputText !== undefined) {
        localVarQueryParameter['CaptchaInput.Text'] = captchaInputText;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiDeleteTicketGet - axios parameter creator
 * 
 * @param {number} reserveId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiDeleteTicketGetAxiosParamCreator (reserveId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiDeleteTicketGet', 'reserveId', reserveId)
    const localVarPath = `/api/DeleteTicket`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveId !== undefined) {
        localVarQueryParameter['reserveId'] = reserveId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiFinalizeReserveGet - axios parameter creator
 * 
 * @param {number} reserveID 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiFinalizeReserveGetAxiosParamCreator (reserveID: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveID' is not null or undefined
    assertParamExists('apiFinalizeReserveGet', 'reserveID', reserveID)
    const localVarPath = `/api/FinalizeReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['reserveID'] = reserveID;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiGetCaptchaGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiGetCaptchaGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetCaptcha`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiGetPenaltyGet - axios parameter creator
 * 
 * @summary Get penalty percent for a reserve
 * @param {number} reserveID 
 * @param {boolean} [isManual] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiGetPenaltyGetAxiosParamCreator (reserveID: number, isManual?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveID' is not null or undefined
    assertParamExists('apiGetPenaltyGet', 'reserveID', reserveID)
    const localVarPath = `/api/GetPenalty`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['reserveID'] = reserveID;
    }

    if (isManual !== undefined) {
        localVarQueryParameter['isManual'] = isManual;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiGetSourceGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiGetSourceGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetSource`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiGetTicketsGet - axios parameter creator
 * 
 * @param {number} reserveID 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiGetTicketsGetAxiosParamCreator (reserveID: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveID' is not null or undefined
    assertParamExists('apiGetTicketsGet', 'reserveID', reserveID)
    const localVarPath = `/api/GetTickets`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['reserveID'] = reserveID;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiRegisterInfoPost - axios parameter creator
 * 
 * @summary Register information of people for reserve
 * @param {RegisterInfoRequest} [registerInfoRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiRegisterInfoPostAxiosParamCreator (registerInfoRequest?: RegisterInfoRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/RegisterInfo`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerInfoRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiReserveFinalizeManualReserveIdPost - axios parameter creator
 * 
 * @param {number} reserveId 
 * @param {FinalizeManualReserveRequest} [finalizeManualReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiReserveFinalizeManualReserveIdPostAxiosParamCreator (reserveId: number, finalizeManualReserveRequest?: FinalizeManualReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveFinalizeManualReserveIdPost', 'reserveId', reserveId)
    const localVarPath = `/api/Reserve/FinalizeManual/{reserveId}`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(finalizeManualReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiReserveReportRefundGet - axios parameter creator
 * 
 * @param {string} [date] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiReserveReportRefundGetAxiosParamCreator (date?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/Report/Refund`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiReserveReportSaleGet - axios parameter creator
 * 
 * @param {string} [date] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiReserveReportSaleGetAxiosParamCreator (date?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/Report/Sale`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiReserveSeatGet - axios parameter creator
 * 
 * @summary Reserve seat for a train
 * @param {number} [trainID] 
 * @param {string} [priceId] 
 * @param {number} [seatCount] 
 * @param {number} [genderCode] 
 * @param {boolean} [exclusive] 
 * @param {boolean} [includeOptionalServices] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {number} [billID] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiReserveSeatGetAxiosParamCreator (trainID?: number, priceId?: string, seatCount?: number, genderCode?: number, exclusive?: boolean, includeOptionalServices?: boolean, adultCount?: number, childCount?: number, infantCount?: number, billID?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ReserveSeat`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (trainID !== undefined) {
        localVarQueryParameter['trainID'] = trainID;
    }

    if (priceId !== undefined) {
        localVarQueryParameter['PriceId'] = priceId;
    }

    if (seatCount !== undefined) {
        localVarQueryParameter['SeatCount'] = seatCount;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['GenderCode'] = genderCode;
    }

    if (exclusive !== undefined) {
        localVarQueryParameter['Exclusive'] = exclusive;
    }

    if (includeOptionalServices !== undefined) {
        localVarQueryParameter['IncludeOptionalServices'] = includeOptionalServices;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['AdultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['ChildCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['InfantCount'] = infantCount;
    }

    if (billID !== undefined) {
        localVarQueryParameter['BillID'] = billID;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiReserveStartManualPost - axios parameter creator
 * 
 * @param {StartManualReserveRequest} [startManualReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiReserveStartManualPostAxiosParamCreator (startManualReserveRequest?: StartManualReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/StartManual`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(startManualReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReservesApiApiReverseCancelGet - axios parameter creator
 * 
 * @param {number} reserveID 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReservesApiApiReverseCancelGetAxiosParamCreator (reserveID: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveID' is not null or undefined
    assertParamExists('apiReverseCancelGet', 'reserveID', reserveID)
    const localVarPath = `/api/ReverseCancel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveID !== undefined) {
        localVarQueryParameter['reserveID'] = reserveID;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCancelBeforeReserveGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiCancelBeforeReserveGetRequest
 */
export interface ReservesApiApiCancelBeforeReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCancelBeforeReserveGet
     */
    readonly reserveID: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCancelBeforeReserveGet
     */
    readonly performerId?: number
}

/**
 * Request parameters for apiCancelPost operation in ReservesApi.
 * @export
 * @interface ReservesApiApiCancelPostRequest
 */
export interface ReservesApiApiCancelPostRequest {
    /**
     * 
     * @type {CancelRequest}
     * @memberof ReservesApiApiCancelPost
     */
    readonly cancelRequest?: CancelRequest
}

/**
 * Request parameters for apiCheckFinalizabilityGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiCheckFinalizabilityGetRequest
 */
export interface ReservesApiApiCheckFinalizabilityGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCheckFinalizabilityGet
     */
    readonly billId?: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCheckFinalizabilityGet
     */
    readonly reserveID?: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCheckFinalizabilityGet
     */
    readonly captchaInputId?: number

    /**
     * 
     * @type {string}
     * @memberof ReservesApiApiCheckFinalizabilityGet
     */
    readonly captchaInputText?: string
}

/**
 * Request parameters for apiCheckReserveGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiCheckReserveGetRequest
 */
export interface ReservesApiApiCheckReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCheckReserveGet
     */
    readonly reserveID?: number

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCheckReserveGet
     */
    readonly overrideTooManyRequests?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCheckReserveGet
     */
    readonly overrideLastUser?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCheckReserveGet
     */
    readonly writeComments?: boolean
}

/**
 * Request parameters for apiCompleteReserveGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiCompleteReserveGetRequest
 */
export interface ReservesApiApiCompleteReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly reserveID?: number

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly overrideTooManyRequests?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly overrideLastUser?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly doCheckReserve?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly writeComments?: boolean

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly captchaInputId?: number

    /**
     * 
     * @type {string}
     * @memberof ReservesApiApiCompleteReserveGet
     */
    readonly captchaInputText?: string
}

/**
 * Request parameters for apiDeleteTicketGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiDeleteTicketGetRequest
 */
export interface ReservesApiApiDeleteTicketGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiDeleteTicketGet
     */
    readonly reserveId: number
}

/**
 * Request parameters for apiFinalizeReserveGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiFinalizeReserveGetRequest
 */
export interface ReservesApiApiFinalizeReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiFinalizeReserveGet
     */
    readonly reserveID: number
}

/**
 * Request parameters for apiGetPenaltyGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiGetPenaltyGetRequest
 */
export interface ReservesApiApiGetPenaltyGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiGetPenaltyGet
     */
    readonly reserveID: number

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiGetPenaltyGet
     */
    readonly isManual?: boolean
}

/**
 * Request parameters for apiGetTicketsGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiGetTicketsGetRequest
 */
export interface ReservesApiApiGetTicketsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiGetTicketsGet
     */
    readonly reserveID: number
}

/**
 * Request parameters for apiRegisterInfoPost operation in ReservesApi.
 * @export
 * @interface ReservesApiApiRegisterInfoPostRequest
 */
export interface ReservesApiApiRegisterInfoPostRequest {
    /**
     * 
     * @type {RegisterInfoRequest}
     * @memberof ReservesApiApiRegisterInfoPost
     */
    readonly registerInfoRequest?: RegisterInfoRequest
}

/**
 * Request parameters for apiReserveFinalizeManualReserveIdPost operation in ReservesApi.
 * @export
 * @interface ReservesApiApiReserveFinalizeManualReserveIdPostRequest
 */
export interface ReservesApiApiReserveFinalizeManualReserveIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveFinalizeManualReserveIdPost
     */
    readonly reserveId: number

    /**
     * 
     * @type {FinalizeManualReserveRequest}
     * @memberof ReservesApiApiReserveFinalizeManualReserveIdPost
     */
    readonly finalizeManualReserveRequest?: FinalizeManualReserveRequest
}

/**
 * Request parameters for apiReserveReportRefundGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiReserveReportRefundGetRequest
 */
export interface ReservesApiApiReserveReportRefundGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReservesApiApiReserveReportRefundGet
     */
    readonly date?: string
}

/**
 * Request parameters for apiReserveReportSaleGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiReserveReportSaleGetRequest
 */
export interface ReservesApiApiReserveReportSaleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReservesApiApiReserveReportSaleGet
     */
    readonly date?: string
}

/**
 * Request parameters for apiReserveSeatGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiReserveSeatGetRequest
 */
export interface ReservesApiApiReserveSeatGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly trainID?: number

    /**
     * 
     * @type {string}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly priceId?: string

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly seatCount?: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly genderCode?: number

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly exclusive?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly includeOptionalServices?: boolean

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReserveSeatGet
     */
    readonly billID?: number
}

/**
 * Request parameters for apiReserveStartManualPost operation in ReservesApi.
 * @export
 * @interface ReservesApiApiReserveStartManualPostRequest
 */
export interface ReservesApiApiReserveStartManualPostRequest {
    /**
     * 
     * @type {StartManualReserveRequest}
     * @memberof ReservesApiApiReserveStartManualPost
     */
    readonly startManualReserveRequest?: StartManualReserveRequest
}

/**
 * Request parameters for apiReverseCancelGet operation in ReservesApi.
 * @export
 * @interface ReservesApiApiReverseCancelGetRequest
 */
export interface ReservesApiApiReverseCancelGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReservesApiApiReverseCancelGet
     */
    readonly reserveID: number
}

/**
* 
* @param {ReservesApiApiCancelBeforeReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiCancelBeforeReserveGet(requestParameters: ReservesApiApiCancelBeforeReserveGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiCancelBeforeReserveGetAxiosParamCreator(requestParameters.reserveID, requestParameters.performerId, options, configuration);
    const request: () => AxiosPromise<CancelBeforeReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiCancelPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiCancelPost(requestParameters: ReservesApiApiCancelPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiCancelPostAxiosParamCreator(requestParameters.cancelRequest, options, configuration);
    const request: () => AxiosPromise<ReverseCancelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiCheckFailureGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiCheckFailureGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiCheckFinalizabilityGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiCheckFinalizabilityGet(requestParameters: ReservesApiApiCheckFinalizabilityGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiCheckFinalizabilityGetAxiosParamCreator(requestParameters.billId, requestParameters.reserveID, requestParameters.captchaInputId, requestParameters.captchaInputText, options, configuration);
    const request: () => AxiosPromise<CheckFinalizabilityResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary check reserve
* @param {ReservesApiApiCheckReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiCheckReserveGet(requestParameters: ReservesApiApiCheckReserveGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiCheckReserveGetAxiosParamCreator(requestParameters.reserveID, requestParameters.overrideTooManyRequests, requestParameters.overrideLastUser, requestParameters.writeComments, options, configuration);
    const request: () => AxiosPromise<CheckReserveResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiCompleteReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiCompleteReserveGet(requestParameters: ReservesApiApiCompleteReserveGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiCompleteReserveGetAxiosParamCreator(requestParameters.reserveID, requestParameters.overrideTooManyRequests, requestParameters.overrideLastUser, requestParameters.doCheckReserve, requestParameters.writeComments, requestParameters.captchaInputId, requestParameters.captchaInputText, options, configuration);
    const request: () => AxiosPromise<CompleteReserveResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiDeleteTicketGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiDeleteTicketGet(requestParameters: ReservesApiApiDeleteTicketGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiDeleteTicketGetAxiosParamCreator(requestParameters.reserveId, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiFinalizeReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiFinalizeReserveGet(requestParameters: ReservesApiApiFinalizeReserveGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiFinalizeReserveGetAxiosParamCreator(requestParameters.reserveID, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiGetCaptchaGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiGetCaptchaGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<CaptchaResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get penalty percent for a reserve
* @param {ReservesApiApiGetPenaltyGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiGetPenaltyGet(requestParameters: ReservesApiApiGetPenaltyGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiGetPenaltyGetAxiosParamCreator(requestParameters.reserveID, requestParameters.isManual, options, configuration);
    const request: () => AxiosPromise<PenaltyResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiGetSourceGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiGetSourceGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiGetTicketsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiGetTicketsGet(requestParameters: ReservesApiApiGetTicketsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiGetTicketsGetAxiosParamCreator(requestParameters.reserveID, options, configuration);
    const request: () => AxiosPromise<TicketsInfo> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Register information of people for reserve
* @param {ReservesApiApiRegisterInfoPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiRegisterInfoPost(requestParameters: ReservesApiApiRegisterInfoPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiRegisterInfoPostAxiosParamCreator(requestParameters.registerInfoRequest, options, configuration);
    const request: () => AxiosPromise<RegisterInfoResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiReserveFinalizeManualReserveIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiReserveFinalizeManualReserveIdPost(requestParameters: ReservesApiApiReserveFinalizeManualReserveIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiReserveFinalizeManualReserveIdPostAxiosParamCreator(requestParameters.reserveId, requestParameters.finalizeManualReserveRequest, options, configuration);
    const request: () => AxiosPromise<StartManualReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiReserveReportRefundGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiReserveReportRefundGet(requestParameters: ReservesApiApiReserveReportRefundGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiReserveReportRefundGetAxiosParamCreator(requestParameters.date, options, configuration);
    const request: () => AxiosPromise<Array<RefundTicketReportItem>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiReserveReportSaleGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiReserveReportSaleGet(requestParameters: ReservesApiApiReserveReportSaleGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiReserveReportSaleGetAxiosParamCreator(requestParameters.date, options, configuration);
    const request: () => AxiosPromise<Array<SaleTicketReportItem>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Reserve seat for a train
* @param {ReservesApiApiReserveSeatGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiReserveSeatGet(requestParameters: ReservesApiApiReserveSeatGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiReserveSeatGetAxiosParamCreator(requestParameters.trainID, requestParameters.priceId, requestParameters.seatCount, requestParameters.genderCode, requestParameters.exclusive, requestParameters.includeOptionalServices, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.billID, options, configuration);
    const request: () => AxiosPromise<ReserveSeatResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiReserveStartManualPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiReserveStartManualPost(requestParameters: ReservesApiApiReserveStartManualPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiReserveStartManualPostAxiosParamCreator(requestParameters.startManualReserveRequest, options, configuration);
    const request: () => AxiosPromise<StartManualReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReservesApiApiReverseCancelGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReservesApiApiReverseCancelGet(requestParameters: ReservesApiApiReverseCancelGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReservesApiApiReverseCancelGetAxiosParamCreator(requestParameters.reserveID, options, configuration);
    const request: () => AxiosPromise<ReverseCancelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
